module.exports = __webpack_public_path__ + "img/notification_on.9dac106a.svg";